<template>
    <section class="col-12">
        <modal-default ref="team_list" show-footer fixed-height size="large" title="Teams">
            <vue-good-table
                :select-options="{ enabled: true, selectOnCheckboxOnly: true, }"
                @on-selected-rows-change="selectionChanged"
                :sort-options="{
                    enabled: false,
                    initialSortBy: {field: 'label', type: 'asc'}
                  }"
                :columns="columns"
                :rows="rows">
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'label'">
                      <a @click.prevent.stop="getTeam(props.row.id)" href="">{{ props.row.label }}</a>
                    </span>
                    <span v-else-if="props.column.field == 'actions'">
                        <button type="button" @click="removeTeam(props.row.id)" class="btn btn-danger">Remove</button>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
            </vue-good-table>
            <template v-slot:actions>
                <button @click="filterEvents" class="btn btn-info">Apply Filter</button>
                <button @click="addTeam" class="btn btn-primary">Add Team</button>
            </template>
        </modal-default>
        <modal-default ref="team_form_modal" fixed-height size="large" title="Team Management">
            <team-form ref="team_form" @created="closeForm" @updated="closeForm"></team-form>
            <template v-slot:actions>
                <button type="button" @click="$refs.team_form.saveTeam()" class="btn btn-primary"> Save entry</button>

            </template>

        </modal-default>
    </section>
</template>

<script>
import _ from "lodash";
import {URL_BASE} from "../../../utils/helper";
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import TeamMembersComponent from "../teams/TeamMembersComponent.vue";
import TeamForm from "./teams/TeamForm.vue";

export default {
    name: "ScheduleSupervisorOption",
    props: {
        site: {},
    },

    components: {
        TeamForm,
        TeamMembersComponent,
        VueGoodTable,
    },
    data() {
        return {
            columns: [
                {
                    label: 'Team Name',
                    field: 'label',
                },
                {
                    label: 'Actions',
                    field: 'actions',
                    width: '100px',
                    html: true,
                },
            ],
            rows: [],
            ids: [],
            selecteds: [],
            site_id: null,
        };
    },
    async mounted() {
    },
    methods: {

        async updateSelecteds() {
            if (sessionStorage.getItem('rams_teams')) {
                let ramsTeams = await JSON.parse(sessionStorage.getItem('rams_teams'));
                let i = 0;
                let app = this;
                this.rows = this.rows.map((e) => {
                    if (ramsTeams.includes(e.id)) {
                        app.selecteds.push(e);
                        e['originalIndex'] = i;
                        e['vgt_id'] = i;
                        e['vgtSelected'] = true;
                    }
                    i++;
                    return e;
                });
            }
        },
        async showList() {
            await this.getTeams()
            this.$refs.team_list.show();
        },
        async getTeams() {
            let result = await axios.get('teams/list-of-choices?logged=1')
            this.rows = result.data;
            await this.updateSelecteds()
        },
        selectionChanged(params) {
            // params.selectedRows - all rows that are selected (this page)
            this.selecteds = params.selectedRows
        },

        async removeTeam(id) {
            if (confirm('Are you sure?')) {
                await axios.delete(`/teams/${id}`)
                await this.getTeams()
            }
        },
        closeForm() {
            this.getTeams()
            this.$refs.team_form_modal.hide();

        },
        getTeam(teamId) {
            this.$refs.team_form.getTeam(teamId);
            this.$refs.team_form_modal.show();
        },
        addTeam() {
            this.$refs.team_form.newTeam();
            this.$refs.team_form_modal.show();
        },
        filterEvents() {
            sessionStorage.setItem('rams_teams', JSON.stringify(this.selecteds.map((e) => e.id)))

            this.$root.$refs.calendar.teams = this.selecteds.map((e) => e.id)
            this.$root.$refs.calendar.getDataCalendar();

            this.$refs.team_list.hide();

        }
    }
}

</script>

<style>
.vgt-table td, .vgt-table th {
    padding: 2px !important;
    font-size: 12px;
}

</style>
